import { useEffect, useState } from 'react';
import { useChatContext } from '../context/use-chat-context';

export function useCurrentUrl(): string {
  const [url, setUrl] = useState<string>(() => window.location.href);
  const { isSuperserveUi } = useChatContext();

  useEffect(() => {
    if (isSuperserveUi) return;

    const updateUrl = () => setUrl(window.location.href);

    // Handle browser navigation (back/forward)
    window.addEventListener('popstate', updateUrl);

    // Patch pushState and replaceState to catch programmatic navigation
    const originalPushState = history.pushState;
    history.pushState = function (
      data: any,
      unused: string,
      url?: string | URL | null
    ) {
      originalPushState.apply(this, [data, unused, url]);
      updateUrl();
    };

    const originalReplaceState = history.replaceState;
    history.replaceState = function (
      data: any,
      unused: string,
      url?: string | URL | null
    ) {
      originalReplaceState.apply(this, [data, unused, url]);
      updateUrl();
    };

    return () => {
      window.removeEventListener('popstate', updateUrl);
      history.pushState = originalPushState;
      history.replaceState = originalReplaceState;
    };
  }, [isSuperserveUi]);

  return url;
}
